import { ContractsStore } from "../../store/modules/contracts";
import { ConfigStore } from "../../store/modules/config";
import { PropSync } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Vue from "vue";

export class ContractsPanelVue extends Vue {
  /** фЛАГ ОТОБОРАЖЕНИЯ В ОДНУ КОЛОНКУ */
  @PropSync("isSingleCol", { type: Boolean }) syncedIsSingleCol!: boolean;
  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**Стор счетов */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /** Получение кода операции открытие депозита */
  get openDepositOperation(): string {
    return this.configStore.apiData.OperationCodeOfOpenDeposit;
  }

  /** Получение кода операции открытие текущего счета */
  get openCurrentAccountOperation(): string {
    return this.configStore.apiData.OperationCodeOfOpenCurrentAccount;
  }

  /** Флаг заргузки списка счетов */
  get loading(): boolean {
    return this.contractsStore.loading;
  }

  /** Флаг отображения списка скрытых счетов и карт */
  get isHiddenItemsVissible(): boolean {
    return this.configStore.isHiddenItemsVissible;
  }

  /** Флаг отображения списка скрытых счетов и карт */
  get isClosedItemsVissible(): boolean {
    return this.configStore.isClosedItemsVissible;
  }

  /** Ширина окна браузера */
  get windowWidth(): number {
    return this.configStore.windowWidth;
  }

  /** Получение списка контрактов */
  get contracts(): any {
    return this.contractsStore.contracts;
  }

  /** Закрытие бара при одноклоночном варианте */
  hideSideBar() {
    this.$emit("hideSideBar");
  }

  toDepositOpening() {
    this.$router.push(`/operation/0/${this.openDepositOperation}`);
  }

  toAccountOpening() {
    this.$router.push(`/operation/0/${this.openCurrentAccountOperation}`);
  }
  
  goToProducts(): void {
    if (this.$route.name !== 'Products')
      this.$router.push('/products');
  }
}
